import { getMatrixClient } from 'ducks/chat/utils/client'

const eventTileTypes = {
  'm.room.message': 'messages.MessageEvent',
  'm.sticker': 'messages.MessageEvent',
}

const stateEventTileTypes = {
  'm.room.topic': 'messages.TextualEvent',
  'g.state': 'messages.StateEvent',
  'g.assign': 'messages.StateEvent',
}

export function getHandlerTile(ev) {
  const type = ev.getType()

  // don't show verification requests we're not involved in,
  // not even when showing hidden events
  if (type === 'm.room.message') {
    const content = ev.getContent()
    if (content && content.msgtype === 'm.key.verification.request') {
      const client = getMatrixClient()
      const me = client && client.getUserId()
      if (ev.getSender() !== me && content.to !== me) {
        return undefined
      }
      return 'messages.MKeyVerificationRequest'
    }
  }
  // these events are sent by both parties during verification, but we only want to render one
  // tile once the verification concludes, so filter out the one from the other party.
  if (type === 'm.key.verification.done') {
    const client = getMatrixClient()
    const me = client && client.getUserId()
    if (ev.getSender() !== me) {
      return undefined
    }
  }

  // Ensure that g.assign events that doesnt have agent_id doesnt render.
  // This happens when we make the agent a participant of the room without
  // assigning the room to the agent
  if (type === 'g.assign') {
    const { agent_id: agentId } = ev.getContent()
    if (!agentId) return undefined
  }

  return ev.isState() ? stateEventTileTypes[type] : eventTileTypes[type]
}
